<div class="tw-my-4">
  <div
    class="tw-border-2 tw-border-dashed tw-border-grey-200 tw-rounded-lg tw-p-6 md:tw-p-4 tw-text-center tw-cursor-pointer tw-transition-all tw-duration-200 tw-bg-grey-100 tw-min-h-[160px] md:tw-min-h-[120px] tw-flex tw-items-center tw-justify-center hover:tw-border-accent-500 hover:tw-bg-white"
    [class.tw-border-accent-500]="isDragging || selectedFile"
    [class.tw-bg-accent-100]="isDragging || selectedFile"
    [class.tw-border-solid]="isDragging || selectedFile"
    (click)="triggerFileInput(fileInput)"
    (dragleave)="onDragLeave($event)"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)">

    <input
      #fileInput
      class="tw-hidden"
      type="file"
      [accept]="accept"
      (change)="onFileInputChange($event)" />

    <!-- Empty State -->
    <div
      *ngIf="!selectedFile"
      class="tw-flex tw-flex-col tw-items-center">
      <ion-icon
        class="tw-text-[48px] md:tw-text-[40px] tw-text-accent-300 tw-mb-3 md:tw-mb-2"
        name="cloud-upload-outline">
      </ion-icon>
      <h3 class="tw-text-base md:tw-text-sm tw-font-semibold tw-text-accent-500 tw-my-2 md:tw-my-1">{{ title }}</h3>
      <p class="tw-text-sm md:tw-text-xs tw-text-grey-400 tw-m-0">{{ subtitle }}</p>
    </div>

    <!-- File Selected State -->
    <div
      *ngIf="selectedFile"
      class="tw-flex tw-items-center tw-gap-3 tw-w-full">
      <ion-icon
        class="tw-text-[40px] tw-text-accent-500 tw-flex-shrink-0"
        name="document-outline">
      </ion-icon>
      <div class="tw-flex-1 tw-text-left tw-min-w-0">
        <h4 class="tw-text-sm tw-font-semibold tw-text-grey-800 tw-m-0 tw-mb-1 tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap">{{ selectedFile.name }}</h4>
        <p class="tw-text-[13px] tw-text-grey-400 tw-m-0">{{ formatFileSize(selectedFile.size) }} MB</p>
      </div>
      <ion-button
        color="medium"
        fill="clear"
        size="small"
        (click)="clearFile($event)">
        <ion-icon
          name="close-circle-outline"
          slot="icon-only">
        </ion-icon>
      </ion-button>
    </div>
  </div>
</div>
